






























































































import { Card, Icon, OutlinedTextInput } from '@descomplica/vue-components';
import Vue, { PropType } from 'vue';
import { normalizeString } from '../../helpers/normalizeString';

export interface CardInfo {
  content: {
    title: string;
    titleSize?: string;
    disabled?: boolean;
    description?: string | null;
    data?: CardInfoData[] | null;
    icon?: string | null;
    hasInfo?: boolean;
  };
  key: number;
}

export interface CardInfoData {
  description: string | null;
  icon: string | null;
  iconDescription: string | null;
  text: string | null;
}

export default Vue.extend({
  components: { Card, OutlinedTextInput, Icon },
  props: {
    selected: {
      type: Number,
      default: -1,
    },
    searchTitle: {
      type: String,
      default: '',
    },
    searchDisabled: {
      type: Boolean,
      default: false,
    },
    listItems: {
      type: Array as PropType<CardInfo[]>,
      required: true,
    },
  },
  data() {
    return {
      placeholder: this.searchTitle,
      label: this.searchTitle,
      input: '',
      search: '',
      activeCard: this.selected,
      filtredList: this.listItems as CardInfo[],
    };
  },
  computed: {
    hasCardInfoData(): boolean {
      return this.listItems.some(item => item.content.data && item.content.data.length > 0);
    },
  },
  watch: {
    input(value) {
      const valueLowerCase = normalizeString(value);

      const pattern: string = Array.from(valueLowerCase).reduce(
        (accumulator, currentValue, index) =>
          `${accumulator}[^${value.substr(index)}]*?${currentValue}`,
        '',
      );

      const regex = RegExp(pattern);

      this.filtredList = this.listItems.filter((cardItem: CardInfo) =>
        normalizeString(cardItem.content.title).match(regex),
      );
    },
  },
  methods: {
    cardClickHandler(key: number) {
      this.activeCard = key;
      this.$emit(
        'selected',
        this.listItems.find(item => item.key === key),
      );
    },
    onClickInfo(key: number) {
      this.$emit(
        'info',
        this.listItems.find(item => item.key === key),
      );
    },
    searchInputHandler(value: string) {
      this.input = value;
    },
    searchInputFocusHandler() {
      this.label = '';
    },
    searchInputBlurHandler() {
      this.label = this.input.length > 0 ? '' : this.searchTitle;
    },
  },
});
